import React from 'react';

import boxLogoSrc from '~/assets/images/logo-box.svg';
import dropboxLogoSrc from '~/assets/images/logo-dropbox.svg';
import googleDriveLogoSrc from '~/assets/images/logo-google-drive.svg';
import oneDriveLogoSrc from '~/assets/images/logo-one-drive.svg';
import sharepointLogoSrc from '~/assets/images/logo-sharepoint.svg';
import { useIntl } from 'react-intl';
import CardList from '~/ui/components/CardList/CardList';

import ContactIntegrationCard from './ContactIntegrationCard';

function StorageIntegrations() {
  const intl = useIntl();

  const integrations = [
    {
      description: intl.formatMessage({
        id: 'StorageIntegrations.boxDescription',
        defaultMessage:
          'Integrate Evisort with your Box account to sync documents across both systems and automatically bring files added to specified Box folders into Evisort',
        description: 'Description for Box integration',
      }),
      logoSrc: boxLogoSrc,
      title: 'Box',
    },
    {
      description: intl.formatMessage({
        id: 'StorageIntegrations.dropboxDescription',
        defaultMessage:
          'Integrate Evisort with your Dropbox account to sync documents across both systems and automatically bring files added to specified Dropbox folders into Evisort',
        description: 'Description for Dropbox integration',
      }),
      logoSrc: dropboxLogoSrc,
      title: 'Dropbox',
    },
    {
      description: intl.formatMessage({
        id: 'StorageIntegrations.googleDriveDescription',
        defaultMessage:
          'Integrate Evisort with your Google Drive account to sync documents across both systems and automatically bring files added to specified Google Drive folders into Evisort',
        description: 'Description for Google Drive integration',
      }),
      logoSrc: googleDriveLogoSrc,
      title: 'Google Drive',
    },
    {
      description: intl.formatMessage({
        id: 'StorageIntegrations.oneDriveDescription',
        defaultMessage:
          'Integrate Evisort with your OneDrive for Business account to sync documents across both systems and automatically bring files added to specified OneDrive for Business folders into Evisort',
        description: 'Description for OneDrive integration',
      }),
      logoSrc: oneDriveLogoSrc,
      title: 'One Drive',
    },
    {
      description: intl.formatMessage({
        id: 'StorageIntegrations.sharepointDescription',
        defaultMessage:
          'Integrate Evisort with your Sharepoint account to sync documents across both systems and automatically bring files added to specified Sharepoint sites or folders into Evisort',
        description: 'Description for SharePoint integration',
      }),
      logoSrc: sharepointLogoSrc,
      title: 'Sharepoint',
    },
  ];

  return (
    <CardList
      title={intl.formatMessage({
        id: 'StorageIntegrations.title',
        defaultMessage: 'Storage',
        description: 'Title for storage integrations section',
      })}
    >
      {integrations.map(({ description, logoSrc, title }) => (
        <ContactIntegrationCard
          key={title}
          description={description}
          logoSrc={logoSrc}
          rightActionText={intl.formatMessage({
            id: 'StorageIntegrations.setupSyncPair',
            defaultMessage: 'Set up Sync Pair',
            description: 'Button text for setting up sync pair',
          })}
          title={title}
        />
      ))}
    </CardList>
  );
}

export default StorageIntegrations;
